// extracted by mini-css-extract-plugin
export var colorSquare = "_rv-0";
export var danger = "_rv-5";
export var lightPink = "_rv-8";
export var neutralBlue = "_rv-7";
export var neutralYellow = "_rv-6";
export var normal = "_rv-1";
export var primary = "_rv-2";
export var primaryLight = "_rv-3";
export var solidBlack = "_rv-g";
export var solidGreen = "_rv-b";
export var solidLightBlue = "_rv-d";
export var solidNavy = "_rv-c";
export var solidOrange = "_rv-f";
export var solidPink = "_rv-e";
export var solidRed = "_rv-9";
export var solidYellow = "_rv-a";
export var success = "_rv-4";